module.exports = __webpack_public_path__ + "static/iq-planes-8abc44b4cbf0071f13f3ac25698aa831.png";